var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.49 101.723L352.211 256.002L507.49 410.281C510.297 404.414 512 397.928 512 391.002V121.002C512 114.075 510.297 107.59 507.49 101.723Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M467 76H44.9997C38.0727 76 31.5877 77.703 25.7207 80.51L224.184 277.973C241.732 295.521 270.268 295.521 287.816 277.973L486.279 80.51C480.412 77.703 473.927 76 467 76Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51 101.723C1.703 107.59 0 114.075 0 121.002V391.002C0 397.929 1.703 404.415 4.51 410.281L159.789 256.002L4.51 101.723Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331 277.211L309.027 299.184C279.788 328.423 232.211 328.423 202.972 299.184L181 277.211L25.7207 431.49C31.5877 434.297 38.0727 436 44.9997 436H467C473.927 436 480.412 434.297 486.279 431.49L331 277.211Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailColored);
export default __webpack_public_path__ + "static/media/mail-colored.4d55e994c537b69b30a7bccabbdc368a.svg";
export { ForwardRef as ReactComponent };